
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries-sitemap.xml",
      function () {
        return require("private-next-pages/industries-sitemap.xml.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industries-sitemap.xml"])
      });
    }
  